import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { InputText } from "primereact/inputtext";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { useHistory } from "react-router-dom";
import { SplitButton } from "primereact/splitbutton";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { Image } from "primereact/image";
import { baseURL } from "../../Config";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { handlePatchRequest } from "../../services/PatchTemplate";

const ManageMenu = () => {

    const history = useHistory()
    const dispatch = useDispatch()

    const [isActive, setIsActive] = useState(false)
    const [allMenus, setAllMenus] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [acceptButtonClass, setAcceptButtonClass] = useState('p-button-danger');

    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionTemplate = (rowData) => {
        const items = [
            {
                label: 'Edit',
                command: () => handleEditMenu(rowData),
            },
            {
                label: 'Delete',
                command: () => confirm(rowData),
            },
        ];
        return (
            <div className="">
                <SplitButton label="" model={items} />
            </div>
        );
    };

    const confirm = (rowData) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Menu Item?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: acceptButtonClass,
            acceptLabel: 'Yes',
            accept: () => {
                handleDeleteMenu(rowData);
            },
            reject: () => {
                return null;
            },
        });
    };

    const handleDeleteMenu = async (rowData) => {
        setIsActive(true);
        const response = await dispatch(handleDeleteRequest(`/menu/${rowData?._id}`, true, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            await getMenuList();
        }
        setIsActive(false);
    };

    const handleEditMenu = (rowData) => {
        const item = true;
        history.push({
            pathname: './addeditmenu',
            state: {
                isEditable: item,
                rowData: rowData,
            }
        });
    };

    //Get Menu List
    const getMenuList = async () => {
        setIsActive(true);
        const response = await dispatch(handleGetRequest(`/menu/getAll`, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            setAllMenus(response?.data || []);
        }
        setIsActive(false);
    };

    //Get Category List
    const getCategoryList = async () => {
        const response = await dispatch(handleGetRequest(`/category/getAll`, false));
        if (response?.status === 'success' || response?.statusCode === 200) {
            setAllCategories(response?.data || []);
        }
    };

    useEffect(() => {
        getMenuList();
        getCategoryList();
    }, [])

    const dateTemplate = (rowData) => {
        if (rowData?.createdAt) {
            const date = new Date(rowData.createdAt);
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric' 
            });
        }
        return 'N/A';
    };

    const imageTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData?.image || rowData?.imageUrl ? (
                    <Image
                        src={rowData?.imageUrl ? `${baseURL}/${rowData.imageUrl}` : `${baseURL}/${rowData.image}`}
                        alt="Menu"
                        width="60"
                        height="60"
                        preview
                        imageStyle={{ borderRadius: '4px', objectFit: 'cover' }}
                    />
                ) : (
                    <span style={{ color: '#999' }}>No Image</span>
                )}
            </React.Fragment>
        );
    };

    const categoryTemplate = (rowData) => {
        if (rowData?.categoryId?.name) {
            return <Tag value={rowData.categoryId.name} severity="info" />;
        }
        return 'N/A';
    };

    const priceTemplate = (rowData) => {
        return `$${rowData?.price?.toFixed(2) || '0.00'}`;
    };

    const comboTemplate = (rowData) => {
        return (
            <Tag 
                value={rowData?.combo ? 'Yes' : 'No'} 
                severity={rowData?.combo ? 'success' : 'secondary'} 
            />
        );
    };

    const statusTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <InputSwitch
                    className="edit-btn ml-1 mt-2"
                    checked={rowData.isAvailable === true}
                    onChange={(e) => handleStatusUpdate(e?.value, rowData)}
                />
            </div>
        );
    };

    const handleStatusUpdate = async (isAvailable, rowData) => {
        let obj = {
            isAvailable: isAvailable,
        }

        const response = await dispatch(handlePatchRequest(obj, `/menu/${rowData?._id}`, true, true));
        if (response?.status === 'success' || response?.statusCode === 200 || response?.statusCode === 201) {
            await getMenuList(); 
        }
    };

    const categoryFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedCategory}
                options={[{ _id: null, name: 'All Categories' }, ...allCategories]}
                onChange={(e) => {
                    setSelectedCategory(e.value);
                    if (e.value?._id) {
                        // Filter menus by category
                        const filtered = allMenus.filter(menu => menu.categoryId?._id === e.value._id);
                        // You can set a filtered list or use DataTable filter
                    }
                }}
                optionLabel="name"
                placeholder="Select Category"
                className="p-column-filter"
                showClear
            />
        );
    };

    // Filter menus based on selected category
    const filteredMenus = selectedCategory?._id 
        ? allMenus.filter(menu => menu.categoryId?._id === selectedCategory._id)
        : allMenus;

    return (
        <>
            <div className="flex flex-column align-items-start md:flex-row  md:justify-content-between md:align-items-center ">
                <h4 className="mb-0" style={{ fontWeight: '600', letterSpacing: '0.5px', color: 'black' }}>
                    Menu Management
                </h4>
                <div className="flex flex-column align-items-start  md:flex-row md:align-items-center">
                    <span className="p-input-icon-left mr-3 resp-margin my-3 md:my-0">
                        <i className="pi pi-search" />
                        <InputText
                            placeholder="Search"
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            className="search-input"
                        />
                    </span>
                    <div className="mr-3">
                        <Dropdown
                            value={selectedCategory}
                            options={[{ _id: null, name: 'All Categories' }, ...allCategories]}
                            onChange={(e) => setSelectedCategory(e.value)}
                            optionLabel="name"
                            placeholder="Filter by Category"
                            className="w-full"
                            showClear
                        />
                    </div>
                    <div className="">
                        <Button
                            label="Add New Menu"
                            className="Add__New-Button ml-3"
                            icon="pi pi-plus"
                            onClick={() => {
                                const item = false;
                                history.push({
                                    pathname: './addeditmenu',
                                    state: {
                                        isEditable: item,
                                    }
                                });
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="card mt-3">
                <LoadingOverlay
                    active={isActive}
                    spinner={<Triangle
                        height="120"
                        width="120"
                        color="#dc2626"
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgb(38 41 51 / 78%)',
                        })
                    }}
                >
                    <DataTable
                        responsive={true}
                        filters={filters}
                        globalFilterFields={[
                            "title",
                            "desc",
                            "categoryId.name",
                            "price",
                        ]}
                        responsiveLayout="scroll"
                        stripedRows
                        paginator
                        rows={20}
                        value={filteredMenus}
                        emptyMessage="No menu items found"
                        paginatorClassName="custom-paginator"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    >
                        <Column body={imageTemplate} header="Image"></Column>
                        <Column sortable field='title' body={(rowData) => rowData?.title || 'N/A'} header="Title"></Column>
                        <Column sortable field='desc' body={(rowData) => rowData?.desc || 'N/A'} header="Description"></Column>
                        <Column field='categoryId' body={categoryTemplate} header="Category"></Column>
                        <Column sortable field='price' body={priceTemplate} header="Price"></Column>
                        <Column field='combo' body={comboTemplate} header="Combo"></Column>
                        <Column body={statusTemplate} header="Available"></Column>
                        <Column field='createdAt' body={dateTemplate} header="Created Date"></Column>
                        <Column header="Action" body={actionTemplate} />
                    </DataTable>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default ManageMenu;

